import { useAuth } from '@pesto/hubble-shared/providers/AuthProvider/AuthProvider';
import { useEffect, useMemo, type ReactNode } from 'react';

import { useGoRoutes } from '../hooks/useGoRoutes';
import { routes } from '../router/routes';

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const { isAuthenticated } = useAuth();
  const { navigate } = useGoRoutes();

  const accessibleRoutes = useMemo(() => {
    return [routes.quickAppraisal, routes.loginCallback];
  }, []);

  const isAccessibleRoute = accessibleRoutes.includes(window.location.pathname);

  useEffect(() => {
    if (!isAuthenticated() && !isAccessibleRoute) {
      return navigate(routes.login);
    }
  }, [isAuthenticated, navigate, isAccessibleRoute]);

  return <>{children}</>;
};
